export default "__VITE_ASSET__iKn8zHvs__"